export type Url = {
  url: string;
  name: string;
};

export enum TemplateCategory {
  Dashboards = 'dashboards',
  Partials = 'partials',
  Components = 'components',
}

export type ListViewProps = {
  templates: Template[];
  templateCategory: TemplateCategory;
};

export type Template = {
  name: string;
  title?: string;
  createdAt: string;
  updatedAt: string;
  owner: string;
  solution: string;
  tags: string[];
  description?: string;
  author?: string;
};

export type ListViewRows = {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  owner: string;
  solution: string;
  tags: string[];
  description?: string;
  author?: string;
};
